import React from "react";
import { observer } from "mobx-react-lite";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import searchStore from "../../store/searchStore";

function InfoDialog() {
  return (
    <Dialog
      open={searchStore.infoPopupOpened}
      onOpenChange={searchStore.closeInfoPopup}
    >
      <DialogContent className="max-w-md w-full p-0 bg-white px-5 pt-3 pb-5 overflow-hidden booking-dialog-content">
        {/* <DialogHeader className="px-5 pt-3 pb-0">
          <DialogTitle className="text-lg font-bold">title</DialogTitle>
        </DialogHeader> */}
        <div>{searchStore.infoPopupData?.text || ""}</div>
        <div className="tar mt12">
          <button
            type="button"
            className="grayButton red ml12"
            onClick={searchStore.closeInfoPopup}
          >
            Ок
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default observer(InfoDialog);
